import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelChat } from '../types/label-chat.type';

export const updateLabelChatValidationSchema = z.object({
  labelChatId: z.string().min(1, { message: 'Label Chat ID is required' }),
  name: z.string().min(1).optional(),
  color: z.string().min(1).optional(),
});

export type TUpdateLabelChatValidation = z.infer<typeof updateLabelChatValidationSchema>;
export type TUpdateLabelChatPayload = TUpdateLabelChatValidation;
export type TUpdateLabelChatResponse = ApiResponse<TLabelChat>;

export const updateLabelChat = async (payload: TUpdateLabelChatPayload): Promise<TUpdateLabelChatResponse> => {
  const url = `/label-chat/${payload.labelChatId}`;

  const payloadData = {
    ...(payload?.name && { name: payload.name }),
    ...(payload?.color && { color: payload.color }),
  };

  return axiosInstance.patch(url, payloadData);
};

type TUseUpdateLabelChatMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof updateLabelChat, AxiosErrorCustom>;
};

export const useUpdateLabelChatMutation = ({ mutationConfigOptions }: TUseUpdateLabelChatMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: updateLabelChat,
    ...restConfigOptions,
  });
};
